import { ICartNft, INft } from 'interfaces';

export const mapNftForCart = (nft: INft): ICartNft => {
  const {
    id,
    sku,
    created_by: { logo_url, title, user_name },
    media,
    preview,
    name,
    short_description,
    description,
    base_price,
    price,
    formatted_price,
    url_key
  } = nft;
  return {
    id,
    sku,
    creator_title: title,
    creator_user_name: user_name,
    creator_logo_url: logo_url,
    media,
    preview,
    name,
    short_description,
    description,
    base_price: base_price.toString(),
    price: price.toString(),
    formatted_price,
    url_key,
    tax_percent: '',
    tax_amount: '',
    formatted_tax_amount: '',
    mint_amount: '',
    formatted_mint_amount: '',
    total: 0,
    formatted_total: ''
  };
};
